import i18n from '@dms/i18n';
import {TextField} from '@dms/teas';

import {useFormContextWithSubmit} from '../../Tenant/hooks/useFormContextWithSubmit';

export const BillingNameSection = () => {
  const {form, onSubmit} = useFormContextWithSubmit<{billingName: string}>();
  const {
    formState: {errors},
    register,
  } = form;

  return (
    <TextField
      placeholder="–"
      error={!!errors?.billingName?.message}
      helperText={errors?.billingName?.message}
      label={<>*{i18n.t('entity.customer.labels.billingName')}</>}
      {...register('billingName')}
      onBlur={() => {
        onSubmit?.();
      }}
      name="billingName"
    />
  );
};
